import React from 'react';
import { Link } from 'react-router-dom';
import AdminTemplate from './pages/AdminTemplate';

export function NotFound() {
  return <AdminTemplate>
    <h1 className='m-3 text-center'>Страница не найдена</h1>
  </AdminTemplate>;
}
